export const SET_MODULE_LEARNING_LOADING = "SET_MODULE_LEARNING_LOADING";
export const SET_MODULE_LEARNING_ERROR = "SET_MODULE_LEARNING_ERROR";
export const SET_CURRENT_LEARNER_CONTENT = "SET_CURRENT_LEARNER_CONTENT";
export const RESET_MODULE_LEARNING_STATE = "RESET_MODULE_LEARNING_STATE";

export const FETCH_MODULE_PLAYER_REQUEST = "FETCH_MODULE_PLAYER_REQUEST";
export const FETCH_MODULE_PLAYER_SUCCESS = "FETCH_MODULE_PLAYER_SUCCESS";
export const FETCH_MODULE_PLAYER_FAIL = "FETCH_MODULE_PLAYER_FAIL";

export const START_LEARNER_MODULE_REQUEST = "START_LEARNER_MODULE_REQUEST";
export const START_LEARNER_MODULE_SUCCESS = "START_LEARNER_MODULE_SUCCESS";
export const START_LEARNER_MODULE_FAIL = "START_LEARNER_MODULE_FAIL";

export const START_LEARNER_CONTENT_REQUEST = "START_LEARNER_CONTENT_REQUEST";
export const START_LEARNER_CONTENT_SUCCESS = "START_LEARNER_CONTENT_SUCCESS";
export const START_LEARNER_CONTENT_FAIL = "START_LEARNER_CONTENT_FAIL";

export const UPDATE_LEARNER_CONTENT_PROGRESS_REQUEST = "UPDATE_LEARNER_CONTENT_PROGRESS_REQUEST";
export const UPDATE_LEARNER_CONTENT_PROGRESS_SUCCESS = "UPDATE_LEARNER_CONTENT_PROGRESS_SUCCESS";
export const UPDATE_LEARNER_CONTENT_PROGRESS_FAIL = "UPDATE_LEARNER_CONTENT_PROGRESS_FAIL";

export const COMPLETE_LEARNER_CONTENT_REQUEST = "COMPLETE_LEARNER_CONTENT_REQUEST";
export const COMPLETE_LEARNER_CONTENT_SUCCESS = "COMPLETE_LEARNER_CONTENT_SUCCESS";
export const COMPLETE_LEARNER_CONTENT_FAIL = "COMPLETE_LEARNER_CONTENT_FAIL";

export const setModuleLearningLoading = (payload) => ({
    type: SET_MODULE_LEARNING_LOADING,
    payload,
});

export const setModuleLearningError = (payload) => ({
    type: SET_MODULE_LEARNING_ERROR,
    payload,
});

export const setCurrentLearnerContent = (payload) => ({
    type: SET_CURRENT_LEARNER_CONTENT,
    payload,
});

export const resetModuleLearningState = () => ({
    type: RESET_MODULE_LEARNING_STATE,
});

export const fetchModulePlayerRequest = (moduleId) => ({
    type: FETCH_MODULE_PLAYER_REQUEST,
    payload: { moduleId },
});

export const fetchModulePlayerSuccess = (payload) => ({
    type: FETCH_MODULE_PLAYER_SUCCESS,
    payload,
});

export const fetchModulePlayerFail = (payload) => ({
    type: FETCH_MODULE_PLAYER_FAIL,
    payload,
});

export const startLearnerModuleRequest = (moduleId, payload = {}) => ({
    type: START_LEARNER_MODULE_REQUEST,
    payload: { moduleId, payload },
});

export const startLearnerModuleSuccess = (payload) => ({
    type: START_LEARNER_MODULE_SUCCESS,
    payload,
});

export const startLearnerModuleFail = (payload) => ({
    type: START_LEARNER_MODULE_FAIL,
    payload,
});

export const startLearnerContentRequest = (moduleId, contentId, payload = {}) => ({
    type: START_LEARNER_CONTENT_REQUEST,
    payload: { moduleId, contentId, payload },
});

export const startLearnerContentSuccess = (payload) => ({
    type: START_LEARNER_CONTENT_SUCCESS,
    payload,
});

export const startLearnerContentFail = (payload) => ({
    type: START_LEARNER_CONTENT_FAIL,
    payload,
});

export const updateLearnerContentProgressRequest = (moduleId, contentId, payload = {}) => ({
    type: UPDATE_LEARNER_CONTENT_PROGRESS_REQUEST,
    payload: { moduleId, contentId, payload },
});

export const updateLearnerContentProgressSuccess = (payload) => ({
    type: UPDATE_LEARNER_CONTENT_PROGRESS_SUCCESS,
    payload,
});

export const updateLearnerContentProgressFail = (payload) => ({
    type: UPDATE_LEARNER_CONTENT_PROGRESS_FAIL,
    payload,
});

export const completeLearnerContentRequest = (moduleId, contentId, payload = {}) => ({
    type: COMPLETE_LEARNER_CONTENT_REQUEST,
    payload: { moduleId, contentId, payload },
});

export const completeLearnerContentSuccess = (payload) => ({
    type: COMPLETE_LEARNER_CONTENT_SUCCESS,
    payload,
});

export const completeLearnerContentFail = (payload) => ({
    type: COMPLETE_LEARNER_CONTENT_FAIL,
    payload,
});
